import React, { useState } from "react";

import Avatar from "../../../ui/avatar/Avtar";

import { DropdownWrapper } from '../../../ui/dropdownwrapper/DropdownWrapper'

const AssigneeSelect = ({
    selectedAssignee,
    assignees,
    allowEdit,
    onChangeAssignee,
    closeOnSelect,
    size = "small",
    shape = "circle",
    position = "right",
}) => {
    const [searchTerm, setSearchTerm] = useState("");

    const filteredAssignees = (assignees || []).filter(assignee =>
        assignee.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="taskgrid-assignee-avatar-dropdown">
            <DropdownWrapper
                toggleElement={
                    selectedAssignee ? (
                        <Avatar
                            size={size}
                            shape={shape}
                            position={position}
                            src={selectedAssignee.avatar || ''}
                            alt={selectedAssignee.label}
                        />
                    ) : (
                        // Without an assignee the avatar fell back to initials of the
                        // placeholder text and read as a real person named "A".
                        <span className="taskgrid-assignee-unassigned" title="Unassigned">
                            N/A
                        </span>
                    )
                }
                closeOnSelect={closeOnSelect}
            >
                {allowEdit && (
                    <div className="taskgrid-avatar-select-dropdown">
                        <div className="taskgrid-avatar-searchbar">
                            <input
                                type="text"
                                placeholder="Search Assignee..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <div className="taskgrid-avatar-list">
                            {filteredAssignees.length > 0 ? (
                                filteredAssignees.map((assignee) => (
                                    <button
                                        key={assignee.value}
                                        type="button"
                                        className="taskgrid-avatar-item"
                                        onClick={() => onChangeAssignee(assignee)}
                                    >
                                        <Avatar
                                            src={assignee.avatar}
                                            alt={assignee.label}
                                            size="small"
                                            shape="circle"
                                            position="top"
                                        />
                                        <div className="taskgrid-avatar-name">{assignee.label}</div>
                                    </button>
                                ))
                            ) : (
                                <div className="taskgrid-no-records">No record found</div>
                            )}
                        </div>
                    </div>
                )}
            </DropdownWrapper>
        </div>
    );
};

export default AssigneeSelect;
